export enum AssistantLearnStatus {
  LEARNING = 'learning',
  READY = 'ready',
  FAILED = 'failed',
}

export const AssistantLearnStatusText = {
  [AssistantLearnStatus.LEARNING]: '学习中',
  [AssistantLearnStatus.READY]: '已学习',
  [AssistantLearnStatus.FAILED]: '学习失败',
};

export enum AssistantChatSource {
  EHR = 'ehr',
  DINGTALK = 'dingtalk',
}

export const AssistantChatSourceText = {
  [AssistantChatSource.EHR]: 'EHR',
  [AssistantChatSource.DINGTALK]: '钉钉',
};

export enum AssistantMessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}

export const AssistantUnansweredTypeText: Record<string, string> = {
  knowledge_miss: '知识未命中',
  data_miss: '数据未命中',
  intent_unclear: '意图不清',
};

export const ASSISTANT_CHAT_BUSY_REASON = 'conversation_busy';

export const ASSISTANT_CHAT_BUSY_MESSAGE =
  '当前会话正在其他页面回复中，请稍后再试';

export const ASSISTANT_CONFIG_CHANGE_EVENT = 'ehr-assistant-config-change';

export const ASSISTANT_CONFIG_POLL_MS = 60000;

export const ASSISTANT_KNOWLEDGE_POLL_MS = 10000;

export const ASSISTANT_ACCEPT_FILES = '.pdf,.doc,.docx,.txt,.md';

export const ASSISTANT_ACCEPT_EXTS = ['pdf', 'doc', 'docx', 'txt', 'md'];

export const ASSISTANT_ACCEPT_FILE_TIP = '仅支持 PDF、Word、TXT、MD';

export const ASSISTANT_MY_CHAT_PAGE_SIZE = 20;
